import React from 'react';
import { string, bool } from 'prop-types';
import { useFeatureContext } from '.';
import { useStorageState } from '../../hooks/useGlobalState';
import useFetchAllPlans from '../../hooks/useFetchAllPlans';
import { Banner } from '@chaser/components';

const plans = ['basic_v2', 'standard_v2', 'professional_v2', 'enterprise_v2'];

const FeatureBetaBanner = ({ title, hidden = false }) => {
  const { data: invoicePlans } = useFetchAllPlans({
    suspense: false,
  });
  const feature = useFeatureContext();
  const [state, setStorageState] = useStorageState('features');
  const key = `${feature.name}Banner`;
  const shown = state[key] ?? true;
  const minimalPlan = plans.find(p => feature.plans?.includes(p));

  if (
    !invoicePlans ||
    !invoicePlans[minimalPlan] ||
    !shown ||
    hidden ||
    !feature.beta ||
    !!minimalPlan
  )
    return null;

  return (
    <Banner intent="info" onClose={() => setStorageState({ [key]: false })}>
      {title || 'This feature'} is currently in beta and accessible for all users but will be
      limited to {invoicePlans[minimalPlan].title}{' '}
      {minimalPlan === 'enterprise_v2' ? '' : '(and above)'} subscription plans in the future
    </Banner>
  );
};

FeatureBetaBanner.propTypes = {
  hidden: bool,
  title: string,
};

export default FeatureBetaBanner;
